import { ActionReducerMap } from "@ngrx/store";
import { sessionAuthData, sessionUserData } from "../interfaces/states-data";
import { sessionAuthReducer } from "./session-auth/session-auth.reducers";
import { venuesReducer } from "./venues/venues.reducers";
import { sessionUserReducer } from "./session-user/session-user.reducers";
import { experiencesReducer } from "./experiences/experiences.reducers";
import { whiteLabelReducer } from "./white-label/white-label.reducers";
import { WhiteLabelConfig } from "./white-label/white-label.actions";

export interface AppState {
    sessionAuthState: sessionAuthData;
    sessionUserState: sessionUserData;
    experiencesState: any;
    venuesState: any;
    whiteLabelState: WhiteLabelConfig;
}

export const ROOT_REDUCERS: ActionReducerMap<AppState> = {
    sessionAuthState: sessionAuthReducer,
    sessionUserState: sessionUserReducer,
    experiencesState: experiencesReducer,
    venuesState: venuesReducer,
    whiteLabelState: whiteLabelReducer,
}